import React from "react";
import { useAuth } from "@/lib/auth";
import { QRCodeImage, downloadQR } from "@/components/QRCodeImage";
import { Download, Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export const RestaurantQR = () => {
  const { restaurant } = useAuth();
  if (!restaurant) return null;
  const url = `${window.location.origin}/m/${restaurant.slug}`;

  return (
    <div data-testid="rest-qr">
      <h1 className="text-2xl font-bold">Your QR code</h1>
      <p className="text-sm text-zq-muted mt-1">Print this on tables or share with customers.</p>

      <div className="grid md:grid-cols-2 gap-6 mt-6">
        <div className="zq-card p-6 text-center">
          <QRCodeImage data={url} size={280} className="mx-auto" />
          <button className="zq-btn zq-btn-primary w-full mt-5" onClick={() => downloadQR(url, `zaykaqr-${restaurant.slug}.png`)} data-testid="qr-download">
            <Download size={16}/> Download PNG
          </button>
        </div>
        <div className="zq-card p-6">
          <h3 className="font-semibold">Menu URL</h3>
          <div className="flex gap-2 mt-3">
            <input className="zq-input flex-1 text-xs" readOnly value={url} />
            <button className="zq-btn zq-btn-outline" onClick={() => { navigator.clipboard.writeText(url); toast.success("Copied"); }} data-testid="qr-copy"><Copy size={16}/></button>
            <a href={url} target="_blank" rel="noreferrer" className="zq-btn zq-btn-outline" data-testid="qr-open"><ExternalLink size={16}/></a>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-3">
            <div className="zq-card p-4">
              <div className="text-xs text-zq-muted">QR scans</div>
              <div className="text-2xl font-bold mt-1">{restaurant.qr_scans || 0}</div>
            </div>
            <div className="zq-card p-4">
              <div className="text-xs text-zq-muted">Menu views</div>
              <div className="text-2xl font-bold mt-1">{restaurant.menu_views || 0}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
